<template>
  <div class="detail-wrap">
    <el-form ref="editForm" :model="tenant">
      <div class="d-header clearfix">
        <div class="fl">
          <i class="el-icon-info"/>
          {{ dataId ? '查看' : '新增' }}地区结算系数
          <span v-show="!this.dataId==0">地区结算系数：[{{this.dataId}}]</span>
        </div>
        <div class="fr">
          <el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-refresh-right">重置
          </el-button>
          <el-button type="primary" class="button-sty" icon="el-icon-check" @click="saveData">保存</el-button>
        </div>
      </div>
      <div>

        <!-- 品牌信息 -->
        <div class="d-cont edit-mce-box">
          <div class="d-item">
            <div class="title first">
              <b>主信息</b>
            </div>
            <table class="table-detail">
              <tbody>
              <tr>
                <th>
                  <em class="f-red">*</em>
                  网点名称
                </th>
                <td>
                  <el-input style="width: 165px;" type="text" autocomplete="off" v-model="formData.siteName" clearable :readonly="true">
                    <i slot="suffix" class="el-input__icon el-icon-search" @click="showPreconditionDialog2=true"></i>
                  </el-input>
                </td>

                <th>
                  <em class="f-red">*</em>
                  是否启用
                </th>
                <td>
                  <el-select v-model="formData.usable" style="width: 165px;">
                    <el-option label="否" :value="0"/>
                    <el-option label="是" :value="1"/>
                  </el-select>
                </td>
              </tr>
              <tr>
                <th>
                  <em class="f-red">*</em>
                  {{$t('common.district')}}:
                </th>
                <td colspan="3">
                  <el-form-item>
                    <template>
                      <el-cascader     :props="areaProps" v-model="areaValues" clearable style="width:23vw;"


                                       :before-filter="areaBeforeFilter"
                                       @myInput="handleInput"
                                       @change="handleChange" ref="cascaderAddr" :options="areaOption">
                      </el-cascader>
                    </template></el-form-item>
                </td>
              </tr>
              <tr>
                <th>
                  <em class="f-red">*</em>
                  结算系数
                </th>
                <td>
                  <el-input v-model="formData.settleCoefficient" autocomplete="off" clearable
                            style="width: 165px" type="number" min="0" max="1" step="0.01" />
                </td>
                <th>
                  <em class="f-red">*</em>
                  赛道
                </th>
                <td>
                  <el-select v-model="formData.battleChannel" style="width: 165px;">
                    <el-option label="线上渠道" :value="1"/>
                    <el-option label="新零售" :value="2"/>
                    <el-option label="线下渠道" :value="3"/>
                  </el-select>
                </td>
              </tr>
              <tr style="position: relative;height: 36px;">
                <th>
                  <em class="f-red">*</em>开始时间
                </th>
                <td>
                  <el-date-picker type="date" placeholder="选择日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                                  v-model="formData.beginDate" clearable/>
                </td>
                <th>
                  <em class="f-red">*</em>结束时间
                </th>
                <td>
                  <el-date-picker type="date" placeholder="选择日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                                  v-model="formData.endDate" clearable/>
                </td>
              </tr>
              <tr>
                <th>创建人</th>
                <td>{{ formData.createBy }}</td>
                <th>创建时间</th>
                <td>{{ formData.createTime }}</td>
              </tr>
              </tbody>
            </table>
          </div>

        </div>

      </div>
    </el-form>

    <sitePop v-if="showPreconditionDialog2" :visiable.sync="showPreconditionDialog2" :multi="true"
             @commit="commitSelectedRow1"/>

  </div>
</template>
<script>
import Tinymce from '@/components/Tinymce';
import preconditionDialog from '@/views/dialogCommon/chanPinDialog.vue';
import sitePop from '@/views/dialogCommon/radioSiteDialog.vue';
import api from "@/api/projectApi";
import { mapGetters } from "vuex";


export default {
  name: 'edit',
  props: {
    _dataId: [String, Number]
  },
  components: {
    preconditionDialog,
    sitePop,
    Tinymce,
  },
  data() {
    return {
      getDataUrl: '/basic/snSiteAreaSettleCoefficient/getById',
      addDataUrl: '/basic/snSiteAreaSettleCoefficient/add',
      updateDataUrl: '/basic/snSiteAreaSettleCoefficient/update',
      activeName: 'first',
      dialog: {
        one: false,
      },
      areaValues: [],
      areaOption: [],
      isEdit: false,
      tabIndex: 'first',
      dataId: '',
      // 基本信息
      tenant: {
        status: 0,
        tenantAttachmentDTOs: []
      },
      areaProps: {
        lazy: true,
        checkStrictly: true,
        lazyLoad: this.cascaderLazyLoad
      },
      showPreconditionDialog2: false,
      showItemPop: false,
      formData: {
        id: null,  // 主键id,自动新增
        createBy: null,  // 创建人
        createTime: null,  // 创建时间
        siteId: null,  // 标准名称
        siteName: null,
        usable: null,  // 是否启用
        battleChannel : null,  // 完工方式
        settleCoefficient: null,  // 结算系数
        areaId: null,  // 地区ID,关联bas_area.id
        beginDate: null,  // 开始时间，注意格式为年月日  yyyy-mm-dd
        endDate: null,  // 结束时间，注意格式为年月日  yyyy-mm-dd
        date: null
      },
    }
  },

  computed: {
    ...mapGetters(["permissions"]),
  },

  created() {
    if (this._dataId && !isNaN(this._dataId)) this.dataId = this._dataId;
  },
  watch: {
    areaValues: {
      handler(newVal, oldVal) {
        if (newVal.length === 0 && oldVal!=null && oldVal.length > 0) {
          // this.clear()
        }
      },
      deep: true,
      immediate: true
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    // 地址数据回显
    echoAddress() {
      if (this.formData.areaId !== null && this.formData.areaId !== '' && this.formData.areaId != 0) {
        // this.cascaderShow = false
        this.$http({
          url: api.basArea.echoAddressUrl,
          method: 'post',
          data: { id: this.formData.areaId }
        }).then(res => {
          console.log(res)
          this.areaOption = res.data.data.options
          this.areaValues = res.data.data.values
          this.area = res.data.data.names
        })
      }
    },
    handleChange(value) {
      const areaNode = this.$refs["cascaderAddr"].getCheckedNodes();
      if (this.keyWord) {
        this.clear()
        this.formData.areaId = areaNode[0].value;
        this.$http({
          url: api.basArea.echoAddressUrl,
          method: 'post',
          data: {id: this.formData.areaId}
        }).then(res => {
          // console.log(res)
          this.areaOption = res.data.data.options
          this.areaValues = res.data.data.values
          // this.area = res.data.data.names
          this.formData.areaId = res.data.data.areaId
        })
      }
      if (areaNode != null && areaNode[0] != null && areaNode[0].value != null) {
        this.formData.areaId = areaNode.value;
      } else if (areaNode.length == 0) {
        this.showArea = !this.showArea
        setTimeout(() => {
          this.$nextTick(() => {
            this.showArea = !this.showArea
          })
        }, 10)
      } else {
        if (!this.keyWord) {
          this.formData.areaId = null;
        }
      }
      const panelRefs = this.$refs.cascaderAddr.$refs.panel
      if (panelRefs.activePath.length !== 0) {
        panelRefs.lazyLoad(panelRefs.getCheckedNodes()[0])
      }
    },
    handleInput(val) {
      this.inputWord = val
    },
    areaBeforeFilter(value) {

      console.log("value=====", value)
      this.key++

      this.areaValues = [value]
      console.log(this.areaValues, "输入的值");
      this.$nextTick(() => {
        this.$refs["cascaderAddr"].computePresentText();
      });
      this.keyWord = value
      let params = {}
      if (this.keyWord) { //如果有关键词，带上关键词获取，需要接口支持
        params = {
          areaName: this.keyWord,

        }
      }

      this.$http({
        url: api.basArea.getList,
        method: 'post',
        data: params,
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        let node0 = []
        if (this.keyWord) {
          this.$refs.cascaderAddr.inputValue = this.keyWord
          this.$refs.cascaderAddr.$refs.input.focus()
          this.$refs.cascaderAddr.toggleDropDownVisible()

        }
        const childrens = response.data.data || {};

        const childNodes = childrens.map(item => ({
          value: item.id,
          label: item.areaName,
          leaf: Number(item.hasChild) !== 0
        }))
        console.log(childNodes, "585");
        if (value == 0) {
          this.areaOption = ''
          return
        }
        this.areaOption = childNodes
      })
      return false
    },
    commitSelectedRow1(data) {
      console.log(data, '网点选中')
      this.formData.siteId = data.id
      this.formData.siteName = data.name
    },
    // 回显
    getData() {
      if (this.dataId && !isNaN(this.dataId)) {
        this.isEdit = true;
        this.$http({
          url: this.getDataUrl,
          method: 'post',
          data: {
            id: this.dataId
          },
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          let data = response.data.data || {}
          this.formData = data
          this.echoAddress()
        })
      }
    },
    resetInput() {
      this.$nextTick(() => {
        const that = this.$refs.cascaderAddr
        this.$refs.cascaderAddr.handleInput = function(val, event) {
          that.$emit('myInput', val)
          !that.dropDownVisible && that.toggleDropDownVisible(true)
          if (event && event.isComposing) return
          if (val) {
            that.filterHandler()
          } else {
            that.filtering = false
          }
        }
      })
    },
    clear() {
      this.keyWord = ''
    },
    cascaderLazyLoad(node, resolve) {
      if (!node) {
        return false
      }
      this.formData.areaId = node.value;
      this.resetInput()
      let params = {parentId: node.value}
      if (this.keyWord) {
        return
      }
      this.$http({
        url: api.basArea.getList,
        method: 'post',
        data: params,
        isLoading: true,
        modalStrictly: true,
      }).then(response => {
        let node0 = []
        if (node.root) {
          const childrens = response.data.data || {};
          const childNodes = childrens.map(item => ({
            value: item.id,
            label: item.areaName,
            leaf: Number(item.hasChild) !== 0
          }))
          // 通过调用resolve将子节点数据返回，通知组件数据加载完成
          resolve(childNodes);
        } else {
          const childrens = response.data.data || {};
          let childNodes = []
          let temp = ''
          if (node.children.length !== 0) {
            temp = node.children
            childrens.forEach(item => {
              let flag = false
              temp.forEach(item1 => {
                if (item1.value == item.id) {
                  flag = true  // 当前节点已存在此数据，不追加
                }
              })
              if (!flag) {
                childNodes.push({
                  value: item.id,
                  label: item.areaName,
                  leaf: Number(item.hasChild) !== 0
                })
              }
            })
            resolve(childNodes);
          } else {
            childrens.forEach(item => {
              childNodes.push({
                value: item.id,
                label: item.areaName,
                leaf: Number(item.hasChild) !== 0
              })
            })
            resolve(childNodes);
          }
        }
      })
    },

    saveData() {
      this.$refs.editForm.validate(valid => {
        if (this.formData.siteId === null) {
          this.$message.warning('请选择网点')
          return
        }
        if (this.formData.areaId === null) {
          this.$message.warning('请选择地区')
          return
        }
        if (this.formData.battleChannel === null) {
          this.$message.warning('请选择赛道')
          return
        }
        if (this.formData.beginDate === null) {
          this.$message.warning('请选择开始时间')
          return
        }
        if (this.formData.endDate === null) {
          this.$message.warning('请选择结束时间')
          return
        }
        if (this.formData.settleCoefficient === null) {
          this.$message.warning('请填写结算系数')
          return
        }
        if (this.formData.usable === null) {
          this.$message.warning('请选择是否启用')
          return
        }
        if (valid) {
          this.$baseConfirm('您确定要保存吗？').then(() => {
            this.$mask.open()

            let date = this.formData.date;
            if (date != null && date.length > 0) {
              this.formData.beginDate = date[0]
              this.formData.endDate = date[1]
            }
            this.$http({
              url: this.isEdit ? this.updateDataUrl : this.addDataUrl,
              method: `post`,
              data: this.formData,
              isLoading: true,
            }).then(res => {
              this.$message.success("保存成功！")
              this.$emit('editViewDataUpdate')
              this.$baseReload()
              this.$mask.close()

            }).catch(e => {
              console.error(e)
              this.$message.error("保存失败！")
              this.$mask.close()

            })
          });
        }
      })
    },

  },
};

</script>
<style lang="scss" scoped>

::v-deep .vxe-grid .vxe-grid--pager-wrapper {
  display: block;
  width: 100%;
  position: fixed;
  bottom: -38px !important;
  position: absolute !important;
  z-index: 9999999;
  background-color: #ffffff;
}

.current-date-picker {
  width: 100%;
  border-radius: 2px;
  border-color: #e8e8e8;
  padding: 0 24px 0 8px;
  height: 28px !important;
  line-height: 28px;
}
.current-date-picker[data-v-b58b35ce] {
    width: 85%!important;
    border-radius: 2px;
    border-color: #e8e8e8;
    padding: 0 0px 0 8px!important;
    height: 28px !important;
    line-height: 28px;
}
</style>
